import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/AWS-Developer-Associate-2020.png'


const _hoisted_1 = {
  id: "header",
  class: "columns is-column-mobile is-flex is-flex-wrap-wrap"
}
const _hoisted_2 = { class: "column is-3" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "column is-flex is-flex-direction-column has-text-right is-align-items-flex-end" }
const _hoisted_6 = { class: "is-size-1 is-size-2-mobile" }
const _hoisted_7 = { class: "mb-4 is-size-4 is-size-5-mobile has-text-grey-light" }
const _hoisted_8 = { href: "https://stackoverflow.com/users/1147618/dbramwell" }
const _hoisted_9 = { class: "is-size-3 is-size-4-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("figure", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.avatarUrl,
            class: "is-rounded"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.name), 1),
        _createElementVNode("h6", _hoisted_7, [
          _cache[0] || (_cache[0] = _createTextVNode(" Stack Overflow Reputation: ", -1)),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.stackoverflowRep), 1)
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<h6 class=\"mb-4 is-size-4 is-size-5-mobile\" data-v-1f079714><a href=\"./david_bramler_cv.pdf\" data-v-1f079714>Download CV</a></h6><div class=\"is-size-2\" data-v-1f079714><a href=\"https://stackoverflow.com/users/1147618/dbramwell\" data-v-1f079714><i style=\"color:hsl(27,90%,55%);\" class=\"mr-3 fab fa-stack-overflow\" data-v-1f079714></i></a><a href=\"https://www.linkedin.com/in/david-bramler-423b2136/\" data-v-1f079714><i style=\"color:#0a66c2;\" class=\"mr-3 fab fa-linkedin\" data-v-1f079714></i></a><a href=\"https://github.com/dbramwell\" data-v-1f079714><i style=\"color:#000000;\" class=\"fab fa-github-square\" data-v-1f079714></i></a></div><div class=\"is-flex is-justify-content-flex-start\" data-v-1f079714><a href=\"https://www.credly.com/badges/bb4735ce-1d2d-4a57-a58c-8993e4b81f9a/public_url\" data-v-1f079714><figure class=\"image is-128x128\" data-v-1f079714><img src=\"" + _imports_0 + "\" data-v-1f079714></figure></a></div>", 3))
      ])
    ]),
    _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.summary), 1),
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
  ]))
}